import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import InputTextAcessibilidade from 'components/InputAcessibilidade';
import * as S from './styles';
import * as Style from 'components/Style';

export const ComponentInputText = ({
  label,
  name,
  placeholder,
  control,
  onChange,
  maxLength,
  disabled,
  errors,
  testid = 'Input Text',
  ...rest
}) => {
  return (
    <S.InputContain id="ComponenteText">
      {label && <S.Label>{label}</S.Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <>
              {disabled ? (
                <InputTextAcessibilidade value={field?.value || rest?.value} placeholder={placeholder} />
              ) : (
                <Input
                  {...field}
                  {...rest}
                  placeholder={placeholder}
                  disabled={disabled}
                  maxLength={maxLength}
                  onChange={onChange}
                  data-testid={testid}
                />
              )}
              <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => <Style.GlobalErro>{message}</Style.GlobalErro>}
              />
            </>
          );
        }}
      />
    </S.InputContain>
  );
};

ComponentInputText.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  testid: PropTypes.string,
};

ComponentInputText.defaultProps = {
  // label: null,
  // name: null,
  // placeholder: null,
  // control: {},
  // onChange: () => {},
  // maxLength: 4000,
  // disabled: false,
  // errors: {},
  // testid: 'Input Text',
};

export default ComponentInputText;
